export default {
  // 导航栏
  nav: {
    brandName: "ORedact · 欧睿达",
    products: '产品',
    examples: "效果示例",
    pricing: "API 定价",
    about: '关于我们',
    login: "控制台登录",
    damaya: "打码鸭",
    register: "申请 API 试用"
  },
  
  // 产品模块
  products: {
    textRedaction: '文字隐私处理',
    textRedactionDesc: "按样本评估",
    fileRedaction: '文件隐私处理', 
    fileRedactionDesc: "PDF / JSON / CSV，按样本评估",
    imageRedaction: '图片隐私处理',
    imageRedactionDesc: "人脸、车牌、敏感文字",
    videoRedaction: '视频隐私处理',
    videoRedactionDesc: "人脸、车牌，逐帧跟踪"
  },
  
  // 通用
  common: {
    learnMore: '了解更多',
    getStarted: '开始使用',
    tryNow: "使用打码鸭",
    contactUs: '联系我们',
    viewMore: '查看更多',
    before: "处理前",
    after: "处理后",
    sourceNote: "成片由打码鸭线上流程输出，素材是我们自己拍的手机视频；部分截帧带预览水印。",
    aiNote: "人群、街景、车流三组原图为 AI 生成，不涉及真实个人；处理结果是线上流程的真实输出。",
    startTrial: '开始试用'
  },
  
  // 主页
  home: {
    heroTitle: "图片与视频隐私打码",
    heroSubtitle: "自己处理，用打码鸭；接进系统，用 ORedact API",
    heroDesc: "自动识别人脸、车牌和敏感文字并打码。企业 API 邀请接入：先用你的素材验证效果，再谈接入和费用。",
    heroImageAlt: "AI 生成的街边画面，系统打码的车牌与人脸用绿色标记标出",
    heroImageCaption: "画面为 AI 生成，不涉及真实个人；绿色标记为打码鸭自动打码的人脸与车牌",
    featuresTitle: "能做什么",
    featuresSubtitle: "图片和视频打码可直接使用；文字和文件脱敏先评估样本。",
    featuresDesc: "了解图片与视频的处理方式；文字与文件需求先评估素材、输出格式和交付范围。",
    demoFaceTitle: "人群人脸",
    demoFaceDesc: "AI 生成的人群图，经线上流程处理：所有人脸柔和模糊，衣着和背景不变。拖动滑块对比。",
    demoTextTitle: "图片文字",
    demoTextDesc: "招牌上的电话号码被遮挡，店名等其他文字保留。",
    demoKeepTitle: "保留指定人物",
    demoKeepDesc: "自动结果会打码所有人；在编辑器里把自家孩子设为保留，重新生成后其他人仍被打码。",
    keepBefore: "自动结果",
    keepAfter: "保留后",
    demoNote: "文字和文件脱敏按样本评估，这里不展示。",
    viewDemo: "了解企业 API",
    pathTitle: "你适合哪一种",
    pathDesc: "个人和小团队直接上传处理；要接进自己系统的团队，申请 API 试用。",
    pathDamayaBadge: "网页自助",
    pathDamayaTitle: "打码鸭",
    pathDamayaMore: "了解打码鸭",
    pathDamayaDesc: "上传图片或视频，系统识别人脸、车牌和敏感文字，在编辑器里确认后导出。",
    pathDamayaPoint1: "免费体验额度，按月卡计费",
    pathDamayaPoint2: "可保留指定人物、手动补码；马赛克、模糊、实色、遮眼条、贴纸五种样式",
    pathDamayaPoint3: "在浏览器里复核和下载，不用装软件",
    pathApiBadge: "系统集成 · 邀请接入",
    pathApiTitle: "ORedact API",
    pathApiDesc: "把打码接进你的业务流程：提交任务、查询状态、回调结果。先用你的素材验证，再定规格和费用。",
    pathApiPoint1: "图片按张、视频按秒计量，成功处理才计费",
    pathApiPoint2: "14 天联调试用：100 张图片 + 10 分钟视频",
    pathApiPoint3: "数据保留期、并发和支持范围，开通前书面确认",
    capsTitle: "能力范围",
    capsPrimaryLabel: "现在可接：",
    capsPrimary: "视频和图片里的人脸、车牌、敏感文字。",
    capsAssessLabel: "先评估再接：",
    capsAssess: "文字和文件脱敏。",
    factsTitle: "能力与规则",
    factsDesc: "打码鸭和企业 API 实际提供的能力，以及接入时的计费与数据规则。",
    fact1: "识别对象：人脸、车牌、图片里的敏感文字（电话、地址、证件号）。",
    fact2: "整条视频逐帧处理，移动中的人脸和车牌按轨迹连续覆盖，不只处理关键帧。",
    fact3: "处理后可在编辑器逐个复核：保留指定人物、补画区域，重新生成不用重传。",
    fact4: "成片按源视频规格输出，保留音轨；支持 4K 和 HEVC 源文件。",
    fact5: "API 只对成功处理计费；系统失败不扣费，自动重试不重复计费。",
    fact6: "源文件、缓存和结果的保留期与删除方式，开通前书面约定。",
    apiTitle: "接入三步",
    apiDesc: "提交任务、查询状态、获取结果，也可以配回调。联调时提供接口文档。",
    apiStep1Title: "提交任务",
    apiStep1Desc: "给出文件地址和处理对象（人脸、车牌、敏感文字），可选打码样式和回调地址。",
    apiStep2Title: "查询状态",
    apiStep2Desc: "轮询进度或等回调；排队和查询不计费。",
    apiStep3Title: "获取结果",
    apiStep3Desc: "下载成片和对象清单，在约定保留期内自行保存。",
    apiNote: "流程示意；接口路径和字段以接入文档为准。",
    textRedactionDesc: "了解文字脱敏方式，按样本评估实体范围、输出与接入需求。",
    fileRedactionDesc: "评估 PDF、JSON、CSV、TXT 等文件中的敏感信息处理需求；Office 文件不属于当前标准 API 套餐。",
    imageRedactionDesc: "识别图片中的人脸、车牌与敏感文字，支持模糊、像素化和遮挡；结果需复核。",
    scenariosTitle: "常见场景",
    scenariosDesc: "按素材来源分的四类需求。",
    scenario1Title: "巡检与现场记录",
    scenario1Desc: "手机拍的现场照片和视频，发出去前把旁观者的脸和车牌打掉。",
    scenario2Title: "车务与道路素材",
    scenario2Desc: "车险、维修、道路记录里的车牌和人脸，接进现有系统批量处理。",
    scenario3Title: "内容发布与协作",
    scenario3Desc: "探店、街拍、活动视频发布前处理路人。",
    scenario4Title: "企业系统集成",
    scenario4Desc: "异步提交、查询状态、回传结果，先联调再上线。",
    demoTitle: "处理效果",
    demoDesc: "真实成片帧；实际效果以你的样本为准。",
    ctaTitle: "把打码接进你的业务流程",
    ctaDesc: "企业 API 邀请接入中。告诉我们素材类型、处理量和时效要求，先验证效果，再定方案。",
    freeTrialBtn: "申请 API 试用",
    contactBtn: "查看 API 定价",
    viewMoreExamples: "更多示例"
  },
  
  // 产品页面通用
  productCommon: {
    howItWorks: '工作原理',
    keyFeatures: '核心特性',
    benefits: '产品优势',
    getStarted: '开始使用',
    uploadFile: '上传文件',
    processing: 'AI 处理中',
    downloadResult: '下载结果'
  },
  
  // 页脚
  footer: {
    productsTitle: '产品模块',
    textRedaction: '文字隐私处理',
    fileRedaction: '文件隐私处理',
    imageRedaction: '图片隐私处理',
    videoRedaction: '视频隐私处理',
    supportTitle: '支持中心',
    examples: '示例展示',
    pricing: "API 定价",
    apiDocs: "API 接入流程",
    helpCenter: "计费与接入 FAQ",
    techSupport: '技术支持',
    legalTitle: '法律与政策',
    privacyPolicy: '隐私政策',
    termsOfService: '用户协议',
    security: "数据保留与删除",
    compliance: "服务范围说明",
    contactTitle: '联系我们',
    about: '关于我们',
    copyright: "© 2026 郑州欧睿达信息科技有限公司",
    poweredBy: 'Powered by Readdy',
    products: '产品',
    support: '支持中心',
    documentation: '使用文档',
    apiReference: 'API 参考',
    legal: '法律政策',
    contact: '联系我们',
    email: '邮箱',
    address: '地址',
    addressValue: '郑州市金水区北环路56号3号楼',
  },
  
  // Text Redaction Page
  'textRedaction.heroTitle': '文字隐私处理',
  'textRedaction.heroSubtitle': "识别文本里的姓名、电话、地址、证件号等，支持中英文混合；具体范围按样本确认。",
  'textRedaction.feature1Title': "中英文混合",
  'textRedaction.feature1Desc': "同一段文本里的中文、英文、数字混排一起识别。",
  'textRedaction.feature2Title': "多类实体",
  'textRedaction.feature2Desc': "姓名、地址、手机号、身份证号、邮箱。",
  'textRedaction.feature3Title': "批量与结构化",
  'textRedaction.feature3Desc': "批量处理文本，按字段输出结果。",
  'textRedaction.tryTitle': "在线试一下",
  'textRedaction.trySubtitle': "这个演示在浏览器里用简单规则做标注和遮盖，不代表正式接口的识别效果。",
  'textRedaction.highlightMode': "标注",
  'textRedaction.redactMode': "遮盖",
  'textRedaction.inputLabel': '输入文本',
  'textRedaction.characters': '字符',
  'textRedaction.inputPlaceholder': '请输入包含隐私信息的文本，例如：我是张三，手机号是13812345678，身份证号是110101199001011234...',
  'textRedaction.outputLabel': "结果",
  'textRedaction.outputPlaceholder': "结果显示在这里",
  'textRedaction.processing': '处理中...',
  'textRedaction.startButton': '开始识别',
  'textRedaction.exampleTitle': '示例文本：',
  'textRedaction.exampleText': '我是张三，现居住在北京市朝阳区建国路88号，手机号码是13812345678，身份证号码是110101199001011234。如有需要请联系我的邮箱zhangsan@email.com。',
  'textRedaction.useExample': '使用此示例',
  'textRedaction.techTitle': "处理方式",
  'textRedaction.techSubtitle': "实体范围和输出格式按样本确定",
  'textRedaction.tech1Title': "实体识别",
  'textRedaction.tech1Desc': "识别姓名、电话、地址、证件号等；覆盖范围以你的样本为准。",
  'textRedaction.tech2Title': "自定义规则",
  'textRedaction.tech2Desc': "可按业务补充词表和正则，覆盖行业特有的编号和字段。",
  'textRedaction.tech3Title': "脱敏方式",
  'textRedaction.tech3Desc': "掩码、替换、泛化三种输出，接入前确定格式。",
  'textRedaction.casesTitle': "常见文本",
  'textRedaction.casesSubtitle': "需求沟通时常见的三类文本，范围以评估结论为准。",
  'textRedaction.case1Title': "业务记录与工单",
  'textRedaction.case1Desc': "客服记录、工单、表单导出里的联系方式和证件号，按字段遮盖。",
  'textRedaction.case2Title': "配套文字",
  'textRedaction.case2Desc': "图片、视频附带的说明、字幕、标注里的个人信息。",
  'textRedaction.case3Title': "调研与访谈记录",
  'textRedaction.case3Desc': "问卷和访谈记录里的个人信息。",
  'textRedaction.ctaTitle': "评估你的文字脱敏需求",
  'textRedaction.ctaSubtitle': "说明文本类型、处理量和输出要求，确认范围后再接入。",
  'textRedaction.ctaButton': "咨询评估",
  
  // Image Redaction Page
  'imageRedaction.heroTitle': '图片隐私处理',
  'imageRedaction.heroSubtitle': "识别人脸、车牌和敏感文字，用模糊、马赛克或实色遮挡。企业 API 先验证样本，结果由你方复核。",
  'imageRedaction.feature1Title': "人脸",
  'imageRedaction.feature1Desc': "多人同框一起识别，近处远处一并处理。",
  'imageRedaction.feature2Title': "车牌",
  'imageRedaction.feature2Desc': "蓝牌、新能源绿牌都识别。",
  'imageRedaction.feature3Title': "敏感文字",
  'imageRedaction.feature3Desc': "图片里的电话、地址、证件号等文字，覆盖范围按样本验证。",
  'imageRedaction.effectTitle': "三种打码样式",
  'imageRedaction.effectSubtitle': "同一帧的三种输出，均为线上流程真实结果（局部放大）。",
  'imageRedaction.blurMode': "模糊",
  'imageRedaction.pixelateMode': "马赛克",
  'imageRedaction.maskMode': "实色",
  'imageRedaction.originalTitle': "原图",
  'imageRedaction.originalDesc': "同一帧",
  'imageRedaction.processedTitle': "处理后",
  'imageRedaction.blurDesc': "模糊：边缘柔和，观感自然",
  'imageRedaction.pixelateDesc': "马赛克：像素块遮挡",
  'imageRedaction.maskDesc': "实色：完全覆盖",
  'imageRedaction.examplesTitle': "处理示例",
  'imageRedaction.examplesSubtitle': "左为未打码原图，右为真实输出",
  'imageRedaction.example1Title': "人群人脸",
  'imageRedaction.example1Desc': "近处远处的脸全部识别并模糊，衣着和背景不变。",
  'imageRedaction.example2Title': "街景：人脸和车牌",
  'imageRedaction.example2Desc': "行人的脸和路边车牌一起遮挡，路牌和店招保留。",
  'imageRedaction.example3Title': "车流车牌",
  'imageRedaction.example3Desc': "多辆车的车牌逐一模糊，车灯和车标不变。",
  'imageRedaction.techTitle': "影响效果的因素",
  'imageRedaction.techSubtitle': "接入前要知道的四点",
  'imageRedaction.tech1Title': "检测效果",
  'imageRedaction.tech1Desc': "受清晰度、目标大小和遮挡影响，先用你的素材验证。",
  'imageRedaction.tech2Title': "处理耗时",
  'imageRedaction.tech2Desc': "异步任务，耗时取决于图片尺寸、内容和排队。",
  'imageRedaction.tech3Title': "打码样式",
  'imageRedaction.tech3Desc': "模糊、马赛克、实色三种可选。",
  'imageRedaction.tech4Title': "参数",
  'imageRedaction.tech4Desc': "打码样式和强度按接入约定配置。",
  'imageRedaction.apiTitle': "API 接入",
  'imageRedaction.apiSubtitle': "申请试用后提供接口文档和示例。",
  'imageRedaction.apiExample': '示例代码',
  'imageRedaction.copyCode': '复制代码',
  'imageRedaction.ctaTitle': "处理你的图片",
  'imageRedaction.ctaSubtitle': "自己用，打开打码鸭；接进系统，申请 API 试用。",
  'imageRedaction.ctaButton1': "使用打码鸭",
  'imageRedaction.ctaButton2': "申请 API 试用",
  
  // File Redaction Page
  'fileRedaction.heroTitle': '文件隐私处理',
  'fileRedaction.heroSubtitle': "文件脱敏按样本评估格式、识别对象和输出方式；不在图片、视频标准 API 单价范围内。",
  'fileRedaction.feature1Title': "格式",
  'fileRedaction.feature1Desc': "优先 PDF、JSON、CSV、TXT；Word、Excel、PowerPoint 单独确认。",
  'fileRedaction.feature2Title': "多页文档",
  'fileRedaction.feature2Desc': "多页 PDF 整份处理，按页输出结果。",
  'fileRedaction.feature3Title': "输出验收",
  'fileRedaction.feature3Desc': "用真实样本确认输出格式、版式和可读性，不默认承诺完全保留原格式。",
  'fileRedaction.formatsTitle': "格式清单",
  'fileRedaction.formatsSubtitle': "用于需求沟通，实际可处理范围以样本验证为准。",
  'fileRedaction.pdf': 'PDF',
  'fileRedaction.pdfDesc': "优先评估",
  'fileRedaction.word': 'Word',
  'fileRedaction.wordDesc': "单独确认",
  'fileRedaction.excel': 'Excel',
  'fileRedaction.excelDesc': "单独确认",
  'fileRedaction.ppt': 'PowerPoint',
  'fileRedaction.pptDesc': "单独确认",
  'fileRedaction.txt': 'TXT',
  'fileRedaction.txtDesc': "优先评估",
  'fileRedaction.rtf': 'RTF',
  'fileRedaction.rtfDesc': "单独确认",
  'fileRedaction.scenariosTitle': "常见文件",
  'fileRedaction.scenariosSubtitle': "需求沟通时常见的四类文件",
  'fileRedaction.scenario1Title': "合同与协议",
  'fileRedaction.scenario1Desc': "甲乙方名称、证件号、联系方式、金额。",
  'fileRedaction.scenario2Title': "表单与登记表",
  'fileRedaction.scenario2Desc': "报名表、登记表导出里的姓名、电话、身份证号。",
  'fileRedaction.scenario3Title': "公示与通知",
  'fileRedaction.scenario3Desc': "公示材料里的身份证号、住址，按规则部分遮盖。",
  'fileRedaction.scenario4Title': "企业档案",
  'fileRedaction.scenario4Desc': "员工档案、人事文件里的个人信息。",
  'fileRedaction.techTitle': "处理方式",
  'fileRedaction.techSubtitle': "文字层优先，扫描件走 OCR",
  'fileRedaction.tech1Title': "OCR",
  'fileRedaction.tech1Desc': "扫描件和图片型 PDF 先识别文字，再定位敏感内容。",
  'fileRedaction.tech2Title': "版面分析",
  'fileRedaction.tech2Desc': "区分正文、表格和图片，定位到具体位置。",
  'fileRedaction.tech3Title': "输出确认",
  'fileRedaction.tech3Desc': "接入前核对脱敏结果和输出格式，约定由你方人工复核的部分。",
  'fileRedaction.ctaTitle': "先确认文件需求",
  'fileRedaction.ctaSubtitle': "说明格式、样本和处理量，评估后给出可交付范围和报价。",
  'fileRedaction.ctaButton1': "咨询文件处理",
  'fileRedaction.ctaButton2': "查看标准 API 范围",
  
  // Video Redaction Page
  'videoRedaction.heroTitle': '视频隐私处理',
  'videoRedaction.heroSubtitle': "逐帧识别并跟踪视频里的人脸和车牌，异步出片。标准 API 首批支持 1080p、30 FPS 以内。",
  'videoRedaction.feature1Title': "跟踪",
  'videoRedaction.feature1Desc': "人脸和车牌在走动、转身时持续跟踪；遮挡、模糊和远处小目标要重点复核。",
  'videoRedaction.feature2Title': "批量",
  'videoRedaction.feature2Desc': "多个视频同时提交，各自异步处理。",
  'videoRedaction.feature3Title': "格式",
  'videoRedaction.feature3Desc': "按编码、帧率、分辨率判断是否支持，不看后缀。",
  'videoRedaction.demoTitle': "真实成片：商场入口 20 秒",
  'videoRedaction.demoSubtitle': "线上流程输出的成片，可播放、取消静音。",
  'videoRedaction.demoCaption': "夜间商场入口的手机视频：路人和家人在走动、转身、进出玻璃门时，脸持续被识别并模糊；其余画面和音轨不变。",
  'videoRedaction.demoFact1': "20 秒 1080×1920，自动识别 149 个对象，13 条人物轨迹。",
  'videoRedaction.demoFact2': "处理后在编辑器逐个复核，可保留指定人物、补画区域后重新生成。",
  'videoRedaction.demoFact3': "成片按源视频规格输出，音轨保留。",
  'videoRedaction.compareTitle': "夜市：多人同时打码",
  'videoRedaction.compareSubtitle': "所有人脸像素化，招牌和商品不变。",
  'videoRedaction.originalVideo': "处理前",
  'videoRedaction.originalDesc': '包含清晰的人脸和车牌信息',
  'videoRedaction.processedVideo': "处理后",
  'videoRedaction.processedDesc': '人脸和车牌已自动打码处理',
  'videoRedaction.featuresTitle': "功能",
  'videoRedaction.featuresSubtitle': "视频处理相关的四点",
  'videoRedaction.feat1Title': "多目标",
  'videoRedaction.feat1Desc': "同一画面里的多张脸、多块车牌一起跟踪处理。",
  'videoRedaction.feat2Title': "分辨率",
  'videoRedaction.feat2Desc': "标准 API 首批 1080p / 30 FPS；4K 和高帧率单独评估。",
  'videoRedaction.feat3Title': "GPU 渲染",
  'videoRedaction.feat3Desc': "GPU 解码、检测和编码，整条流程在服务端完成，浏览器只负责上传和复核。",
  'videoRedaction.feat4Title': "音轨",
  'videoRedaction.feat4Desc': "只改画面，音轨原样保留。",
  'videoRedaction.scenariosTitle': "常见场景",
  'videoRedaction.scenariosSubtitle': "视频素材的四类来源",
  'videoRedaction.scenario1Title': '监控录像',
  'videoRedaction.scenario1Desc': "回放片段里的人脸，导出前处理。",
  'videoRedaction.scenario2Title': "新闻与宣传片",
  'videoRedaction.scenario2Desc': "非当事人的路人和车牌。",
  'videoRedaction.scenario3Title': "教学与培训录像",
  'videoRedaction.scenario3Desc': "学员和旁听者的脸。",
  'videoRedaction.scenario4Title': '会议录像',
  'videoRedaction.scenario4Desc': "参会人员的脸。",
  'videoRedaction.formatsTitle': '支持格式',
  'videoRedaction.formatsSubtitle': "首批验证 MP4 和 MOV（H.264 / HEVC）；其他容器和编码按样本评估。",
  'videoRedaction.mp4': 'MP4',
  'videoRedaction.mp4Desc': "H.264 / HEVC",
  'videoRedaction.mov': 'MOV',
  'videoRedaction.movDesc': "QuickTime，H.264 / HEVC",
  'videoRedaction.other': '其他容器',
  'videoRedaction.otherDesc': '按样本评估',
  'videoRedaction.techTitle': "处理方式",
  'videoRedaction.techSubtitle': "检测、跟踪、渲染三步",
  'videoRedaction.tech1Title': "检测",
  'videoRedaction.tech1Desc': "逐帧检测人脸和车牌。",
  'videoRedaction.tech2Title': "跟踪",
  'videoRedaction.tech2Desc': "把同一目标的检测串成轨迹，减少闪烁；复杂场景仍要检查成片。",
  'videoRedaction.tech3Title': "渲染",
  'videoRedaction.tech3Desc': "GPU 上完成打码和编码，按源规格输出。",
  'videoRedaction.ctaTitle': "处理你的视频",
  'videoRedaction.ctaSubtitle': "自己用，打开打码鸭；接进系统，申请 API 试用。",
  'videoRedaction.ctaButton1': "使用打码鸭",
  'videoRedaction.ctaButton2': "申请 API 试用",

  // Examples Page
  examplesNew: {
    heroTitle: "处理效果示例",
    heroSubtitle: "原图与处理结果并排对比。图片示例为线上流程真实输出，实际效果以你的素材为准。",
    textTitle: "文字脱敏",
    textSubtitle: "识别文本里的姓名、证件号、电话、地址、邮箱，按字段遮盖。",
    before: '处理前',
    after: '处理后',
    idNumber: "证件号码",
    phone: '联系电话',
    homeAddress: "收货地址",
    emailAddress: '电子邮箱',
    demoCustomerName: "张明华", demoHomeAddress: "北京市朝阳区建国路88号",
    customerName: "客户姓名",
    ticketNote: "工单备注",
    ticketContent: "客户反映 10 月 12 日订单未收到，已安排补发，请在 3 日内确认收货。",
    fileCard1Title: "优先评估",
    fileCard1Desc: "PDF、JSON、CSV、TXT：先用真实样本确认识别对象、输出格式和可读性，再接入。",
    fileCard2Title: "需单独确认",
    fileCard2Desc: "Word、Excel、PowerPoint 等 Office 文件不在标准 API 范围，按需求单独评估。",
    fileLink: "文件处理说明",
    textSign: "招牌文字",
    crowdTitle: "人群人脸",
    crowdDesc: "近处和远处 8 张人脸全部识别并柔和模糊；衣着、围巾、背景不变。",
    streetTitle: "街景：人脸和车牌",
    streetDesc: "行人的脸和路边车牌同时遮挡，路牌和店招保留。",
    trafficTitle: "车流车牌",
    trafficDesc: "多辆车的车牌逐一识别并模糊；车灯、车标、路面不变。",
    signDesc: "招牌上的电话号码被遮挡，其余文字保留。",
    keepObject: "保留指定人物",
    keepDesc: "自动结果打码所有人；把自家孩子设为保留后重新生成。",
    keepBefore: "自动结果",
    keepAfter: "保留后",
    mallTitle: "商场入口，20 秒手机视频",
    mallDesc: "路人和家人的脸全部自动识别并模糊；成片保留音轨，可播放、取消静音。",
    editorTitle: "处理后在编辑器复核",
    editorDesc: "对象网格里逐个确认打码或保留，补漏后重新生成，不用重新上传。",
    fileTitle: "文件脱敏",
    fileSubtitle: "按样本评估，不放合成示意图。",
    imageTitle: "图片打码",
    imageSubtitle: "左为未打码原图，右为处理结果，拖动滑块对比。",
    videoTitle: "视频打码",
    videoSubtitle: "成片可直接播放；对象复核和保留在编辑器完成。",
    statsTitle: '处理能力展示',
    statsSubtitle: 'ORedact 的强大处理能力',
    accuracy: '识别准确率',
    accuracyDesc: '基于深度学习的高精度识别',
    speed: '处理速度',
    speedDesc: '单张图片处理时间',
    formats: '支持格式',
    formatsDesc: '文档、图片、视频格式',
    availability: '服务可用性',
    availabilityDesc: '全天候稳定服务',
    ctaTitle: "用你的素材验证一次",
    ctaSubtitle: "申请 API 试用，14 天内用 100 张图片和 10 分钟视频验证效果。",
    freeTrial: "申请 API 试用",
    contactSales: "联系我们",
  },

  // About Page
  aboutNew: {
    heroTitle: '关于我们',
    heroSubtitle: "郑州欧睿达信息科技有限公司，只做图片和视频的隐私打码：自研处理流程和识别模型，线上产品打码鸭，企业 API 邀请接入中。",
    companyTitle: '公司简介',
    companyP1: "我们只做一件事：识别并遮挡图片、视频里的人脸、车牌和敏感文字。打码鸭面向个人和小团队，网页自助；ORedact API 面向要接进自己系统的开发团队。",
    companyP2: "公司在郑州，2025 年 9 月成立，项目 2025 年 7 月启动。处理流程、编辑器和识别模型都是自研，模型用自有素材持续训练，按真实场景持续改进。",
    companyP3: "企业 API 邀请接入：先验证素材和流程，再定价格、容量和支持范围。专属容量和私有化单独评估，暂无标准企业套餐。",
    infoTitle: "公司信息",
    infoCompany: "公司名称",
    infoFounded: "成立时间",
    infoFoundedValue: "2025 年 9 月",
    infoIcp: "ICP 备案",
    infoPsb: "公安备案",
    matrixTitle: "产品矩阵",
    matrixDamayaTitle: "打码鸭 · 网页自助",
    matrixDamayaDesc: "个人创作者和小团队的在线打码工具：上传图片或视频，自动识别人脸、车牌、敏感文字，复核后导出。",
    matrixApiTitle: "ORedact API · 系统集成",
    matrixApiDesc: "面向要把打码接进业务系统的开发团队。当前邀请接入：先验证素材，再定规格、用量和费用。",
    matrixApiCta: "查看 API 定价与申请方式",
    boundaryTitle: "服务边界",
    boundary1: "图片和视频打码可直接使用；文字和文件脱敏按样本评估。",
    boundary2: "暂无标准企业版，不承诺无限量和现成 SLA；专属容量、私有化单独评估。",
    boundary3: "用户上传内容只用于完成该次处理，不用于模型训练。",
    companyImageCaption: "打码鸭编辑器：逐个复核对象，可保留或补码，重新生成。",
    heroChip1: "2025 年 9 月成立 · 郑州",
    heroChip2: "打码鸭 2026 年 4 月上线",
    heroChip3: "识别模型自有素材训练",
    approachTitle: "我们怎么做",
    approachDesc: "打码效果取决于四件事：检出率、追踪稳定性、成片质量和复核效率。我们在这四处下功夫。",
    approach1Title: "一条自研处理流程",
    approach1Desc: "检测、追踪、渲染和编码在同一条 GPU 流水线里完成。成片按源视频规格输出并保留音轨，支持 4K 和 HEVC 源文件。",
    approach2Title: "模型用自有素材持续训练",
    approach2Desc: "车牌模型用自采行车记录仪素材训练；人脸模型针对人群、侧脸和远处小脸持续迭代。2026 年 10 月两者都已换到自训版本。用户上传内容不参与训练。",
    approach3Title: "同一个人整段归并",
    approach3Desc: "视频里同一个人的多次出现会归到一起，保留某个人只需点一次。检测结果可逐帧复核，补画区域后重新生成，不用重传。",
    approach4Title: "按真实场景改进",
    approach4Desc: "每次改动都在自有测试集上逐帧做前后对比，漏检、误打和处理耗时都有记录，再决定是否上线。",
    dataTitle: "数据与安全",
    dataDesc: "以下承诺写在隐私政策和服务条款里。",
    data1: "打码鸭上传的图片、视频和处理结果，在处理完成后 24 小时内自动删除；API 用户的保留期和删除方式在开通前书面约定。",
    data2: "上传内容只用于完成该次处理，不用于训练模型。",
    data3: "服务部署在中国境内，文件存储在阿里云对象存储，传输全程 HTTPS。",
    data4: "网站与服务已完成 ICP 备案和公安备案；隐私政策写明收集范围、保存期限和用户权利。",
    timelineTitle: "发展历程",
    tl1Date: "2025 年 7 月", tl1Text: "项目启动，开始开发打码处理后端与官网。",
    tl2Date: "2025 年 9 月", tl2Text: "郑州欧睿达信息科技有限公司成立。",
    tl3Date: "2025 年 10 月", tl3Text: "视频处理引擎立项：GPU 流水线、人脸与车牌检测、追踪与渲染。",
    tl4Date: "2026 年 3 月", tl4Text: "打码鸭网页产品开始开发。",
    tl5Date: "2026 年 4 月", tl5Text: "打码鸭上线，开放付费下载无水印成片。",
    tl6Date: "2026 年 10 月", tl6Text: "自训车牌、人脸模型上线；处理记录与再次编辑；企业 API 定价公开。",
    resourcesTitle: "相关资料",
    resourceHelp: "打码鸭帮助中心（15 篇使用说明）",
    resourcePrivacy: "隐私政策",
    resourcePricing: "企业 API 定价",
    contactTitle: '联系我们',
    contactSubtitle: "API 接入、用量合作、部署需求，发邮件给我们。",
    emailTitle: '邮箱地址',
    addressTitle: '公司地址',
    addressValue: '郑州市金水区北环路56号3号楼',
    workingHours: '工作时间',
    workingDays: '周一至周五',
    workingTime: '9:00 - 18:00',
  },

  // Pricing Page
  pricing: {
    "status": "企业 API · 邀请接入",
    "heroTitle": "按图片张数与视频时长计费",
    "heroSubtitle": "把图片和视频打码接进你的系统。先用真实素材验证，再定范围、用量和费用。",
    "statusNote": "以下为参考价。申请后经样本验证和商务确认开通，目前不提供在线直接购买。",
    "plansLabel": "API 方案",
    "trialBadge": "先验证处理效果",
    "trialTitle": "联调试用",
    "trialPrice": "免费",
    "trialDesc": "{{trialDays}} 天测试期，走通从提交任务到拿到结果的完整流程。",
    "trialQuota": "{{trialImages}} 张图片 + {{trialVideoMinutes}} 分钟标准视频",
    "trialEligibility": "每组织一次，审核通过后发放测试额度",
    "trialScope": "确认素材规格、打码对象与结果验收方式",
    "applyTrial": "申请 API 试用",
    "standardBadge": "参考价",
    "standardTitle": "标准按量 API",
    "imageLabel": "标准图片",
    "videoLabel": "标准视频",
    "perImage": "/ 张",
    "perMinute": "/ 分钟",
    "startingBalance": "¥{{startingBalance}} 起预充值，无月平台费",
    "standardBilling": "图片按张；视频按秒计量，不按文件 MB 收费",
    "standardDelivery": "处理包含一份无品牌水印结果与正常下载",
    "standardFailure": "系统处理失败不扣费，自动重试不重复扣费",
    "applyStandard": "咨询接入",
    "customBadge": "需求评估",
    "customTitle": "用量合作与专属需求",
    "customPrice": "按范围评估",
    "customDesc": "有稳定批量需求、固定月预算或部署要求，可提交素材与预估用量共同评估。",
    "customVolume": "月度用量承诺、峰值提交量与可接受等待时间",
    "customCapacity": "专属容量、私有化部署及定制接入单独评估",
    "customBoundary": "尚未推出标准企业版，不承诺无限量或现成 SLA",
    "contact": "提交需求",
    "damayaTitle": "只想上传文件直接用？",
    "damayaDesc": "打码鸭面向个人和小团队。套餐和体验规则以打码鸭站内说明为准。",
    "damayaAction": "前往打码鸭",
    "scopeTitle": "先明确规格，再确认费用",
    "imageScopeTitle": "标准图片范围",
    "imageScope": "当前支持：JPEG、PNG、WebP，最高 {{maxImageMegapixels}}MP。先验证人脸、车牌或敏感文字等目标的处理效果。",
    "videoScopeTitle": "标准视频范围",
    "videoScope": "当前支持：最高 {{maxVideoHeight}}p、{{maxVideoFps}} FPS，单条最长 {{maxVideoMinutes}} 分钟。4K、高帧率、复杂文字或密集人群场景单独评估。",
    "billingScopeTitle": "成功处理才计费",
    "billingScope": "视频按输入真实时长向上取整到秒，再按分钟单价折算。排队、状态查询和结果回调不增加处理费；校验不通过及系统处理失败不扣费。",
    "deliveryScopeTitle": "结果交付与服务边界",
    "deliveryScope": "包含一份无品牌水印输出、正常下载与标准接口支持。客户自行复核并保存结果；长期托管、内容分发、定制开发及容量保障另行确认。",
    "exampleTitle": "预算示例：300 人每天各提交 30 秒视频",
    "exampleDesc": "按 30 天计算，共 9,000 条、{{exampleMinutes}} 分钟标准视频。按 ¥{{videoPrice}}/分钟估算，处理费约 ¥{{exampleCost}}/月。",
    "exampleNote": "这是标准范围内、共享算力的用量示例，不是专属服务器套餐或完成时限承诺。实际按成功处理量结算，月度固定预算可另行协商。",
    "processTitle": "从样本验证到正式接入",
    "sampleTitle": "提交需求与样本",
    "sample": "说明处理对象、图片或视频规格、月用量、峰值与交付时间，提供有权处理的代表性素材。",
    "integrationTitle": "完成联调试用",
    "integration": "审核通过后获得测试 Key 与接入资料，验证异步任务、状态查询、结果回调和失败重试。",
    "productionTitle": "确认方案后开通",
    "production": "确认价格、余额期限、数据保留期、并发限额与支持范围，再开通生产调用与用量对账。",
    "faqTitle": "计费与接入常见问题",
    "faq": {
      "prepay": {
        "question": "200 元是月费吗？余额会按月清零吗？",
        "answer": "不是月费，而是开通后用于抵扣成功处理费用的预存余额；无额外月平台费，不按月清零。拟采用 12 个月余额有效期，具体期限、临期提醒与未消耗本金处理方式在开通前书面确认。"
      },
      "failure": {
        "question": "失败、重试或重新处理如何计费？",
        "answer": "系统失败释放预占余额；系统自动重试、同一幂等请求和重复回调不重复计费。主动修改参数并创建新处理任务会重新计费，执行前确认费用；正常结果下载不另收处理费。"
      },
      "formats": {
        "question": "4K、长视频和文档也使用这个单价吗？",
        "answer": "本页单价适用于经验证的标准图片与视频。4K、高帧率、长视频、复杂场景、文本和文档需求先做样本评估，未确认的规格不会自动按标准套餐开通。"
      },
      "retention": {
        "question": "文件保存多久？是否包含长期存储？",
        "answer": "开通前明确源文件、缓存及结果的保留期与删除方式。客户需在有效期内保存结果；本方案不包含长期文件托管，不将处理完成即删除作为统一承诺。"
      },
      "support": {
        "question": "是否包含私有化、专属服务器或 7×24 支持？",
        "answer": "标准 API 使用共享算力，支持范围为工作日接口文档、示例和错误定位。专属容量、私有化、客户系统开发及 SLA 需要单独评估交付范围，目前不是可直接购买的标准商品。"
      },
      "damaya": {
        "question": "与打码鸭套餐可以共用吗？",
        "answer": "打码鸭面向网页自助处理，企业 API 面向系统集成。两者的套餐、试用额度与计费权益独立；打码鸭的具体规则请查看其站内说明。"
      }
    },
    "contactTitle": "先告诉我们你的需求",
    "contactDesc": "邮件写明公司和联系方式、素材类型、月处理量、峰值和期望交付时间。样本传输方式双方再定。",
    "sendApplication": "邮件申请 API 试用",
    "emailAlternative": "也可复制邮箱联系：",
    "aboutLink": "查看公司与联系方式"
  },

  // Privacy Policy Page
  privacyPolicy: {
    heroTitle: '隐私政策',
    lastUpdated: '最后更新时间：2026 年 1 月 6 日',
    introduction: {
      title: '引言',
      p1: '郑州欧睿达信息科技有限公司（以下简称"我们"、"公司"或"ORedact"）为企业和机构提供图片与视频的隐私信息识别与打码服务；文字与文件脱敏经样本评估后提供。',
      p2: '我们深知您所处理的数据可能涉及个人信息、敏感个人信息、医疗或业务机密数据，因此我们将隐私保护与数据安全作为产品设计与运营的核心原则。',
      p3: '本隐私政策旨在说明我们如何收集、使用、存储、保护及处理您的信息，以及您依法享有的相关权利。',
      important: '重要说明：',
      importantNote: 'ORedact 不会将您上传的内容用于模型训练、数据分析、广告用途或任何形式的二次利用，除非获得您的明确书面授权。',
      p4: '使用我们的服务即表示您已阅读并同意本隐私政策的全部内容。',
    },
    section1: {
      title: '1. 我们收集的信息',
      subsection1: {
        title: '1.1 信息类型',
        p1: '我们可能收集以下类别的信息：',
        category1: {
          title: '（1）账户与身份信息',
          items: ['用户名', '邮箱地址', '联系方式', '企业名称、组织信息（如适用）'],
        },
        category2: {
          title: '（2）服务使用与技术信息',
          items: ['登录与访问日志', '功能使用情况与操作记录', 'IP 地址、浏览器类型、设备信息、操作系统'],
        },
        category3: {
          title: '（3）您主动上传的处理数据',
          items: ['文本、文档、图片、音频、视频等内容', '上述内容中可能包含个人信息或敏感个人信息'],
        },
        warning: '特别说明：',
        warningNote: '您上传的处理数据仅用于完成您发起的隐私识别或脱敏任务，我们不会主动查看、分析或留存该等内容。',
      },
      subsection2: {
        title: '1.2 信息收集方式',
        items: [
          '您主动提供的信息（注册账户、上传数据、提交请求等）',
          '系统自动收集的信息（Cookies、日志文件等）',
          '合法第三方服务提供的信息（如支付、身份验证或安全服务）',
        ],
      },
    },
    section2: {
      title: '2. 信息使用目的与处理原则',
      subsection1: {
        title: '2.1 使用目的',
        p1: '我们仅在以下范围内使用您的信息：',
        items: [
          '提供、维护与优化隐私脱敏服务',
          '执行您明确请求的数据处理任务',
          '账户管理、技术支持与服务通知',
          '安全监控、风险控制与防止滥用',
          '遵守法律法规及监管要求',
        ],
      },
      subsection2: {
        title: '2.2 数据处理原则',
        p1: '我们严格遵循以下原则：',
        items: [
          '最小必要原则：仅处理实现服务目的所必需的数据',
          '目的限定原则：不超出明确告知的用途范围',
          '数据隔离原则：不同客户数据相互隔离',
          '客户控制原则：数据由客户主导，可随时删除',
          '不训练原则：不用于 AI 或算法模型训练',
        ],
      },
    },
    section3: {
      title: '3. 数据安全与保护措施',
      subsection1: {
        title: '3.1 技术与管理措施',
        p1: '我们采用符合行业标准的安全措施，包括但不限于：',
        items: [
          'TLS / SSL 加密传输',
          '数据静态加密（如适用）',
          '严格的访问控制与权限分级',
          '操作审计与安全日志',
          '定期漏洞扫描与安全评估',
          '自动化数据备份与灾难恢复机制',
        ],
      },
      subsection2: {
        title: '3.2 数据存储与托管',
        items: [
          '数据存储于符合 ISO 27001 等国际安全标准的数据中心',
          '支持按地区部署（如中国、亚太、欧美）',
          '定期清理不再需要的数据',
        ],
      },
    },
    section4: {
      title: '4. 数据共享与第三方',
      p1: '我们不会出售、出租或以其他方式交易您的个人信息。',
      p2: '仅在以下情形下，可能共享必要信息：',
      items: [
        '获得您的明确授权',
        '为履行服务所必需（如支付、云基础设施）',
        '法律法规或监管机关要求',
        '为保护用户、公众或公司合法权益',
      ],
      subsection1: {
        title: '4.1 第三方服务提供商',
        p1: '我们可能使用经审查的第三方服务提供商协助提供服务，其仅可在必要范围内处理数据，并须遵守严格的保密与安全义务。',
      },
    },
    section5: {
      title: '5. 您的权利',
      p1: '根据适用法律（包括《个人信息保护法》《GDPR》），您享有以下权利：',
      items: [
        '访问权',
        '更正权',
        '删除权',
        '限制处理权',
        '数据可携权',
        '反对权',
        '撤回同意权',
      ],
      p2: '如需行使上述权利，请通过本政策所列联系方式与我们联系。',
    },
    section6: {
      title: '6. Cookies 与类似技术',
      p1: '我们使用 Cookies 和类似技术，以确保网站正常运行并提升用户体验。',
      subsection1: {
        title: '6.1 Cookies 类型',
        items: [
          '必要 Cookies：保障网站基本功能',
          '功能 Cookies：保存偏好设置',
          '分析 Cookies：用于匿名统计分析',
          '营销 Cookies：用于提供相关内容（如适用）',
        ],
      },
      p2: '您可通过浏览器设置管理 Cookies 偏好，但禁用部分 Cookies 可能影响网站功能。',
    },
    section7: {
      title: '7. 数据保留期限',
      table: {
        dataType: '数据类型',
        retentionPeriod: '保留期限',
        accountInfo: '账户信息',
        accountInfoPeriod: '账户存续期间',
        processingData: '处理数据',
        processingDataPeriod: "企业 API：按服务协议约定的保留期与删除方式执行；打码鸭：按打码鸭隐私政策执行，本政策不另行规定",
        systemLogs: '系统日志',
        systemLogsPeriod: '最长 12 个月',
        legalData: '法律要求数据',
        legalDataPeriod: '依法保留',
      },
      note: '打码鸭（damaya.cn）上传文件与处理结果的保留与删除，以打码鸭隐私政策为准：',
    },
    section8: {
      title: '8. 数据存储地点与跨境传输',
      p1: '我们的服务在中国境内处理与存储数据。如涉及跨境传输，我们将：',
      items: [
        '依法开展个人信息出境评估或履行其他法定程序',
        '向您告知接收方、处理目的与方式，并取得必要的同意',
        '采取适当的技术与组织保护措施',
      ],
    },
    section9: {
      title: '9. 政策更新',
      p1: '我们可能不时更新本隐私政策。',
      p2: '如发生重大变更，我们将通过网站公告或电子邮件通知您。',
      p3: '继续使用我们的服务即表示您接受更新后的隐私政策。',
    },
    section10: {
      title: '10. 联系我们',
      p1: '如您对本隐私政策或个人信息保护相关事项有任何疑问，',
      p2: '或希望行使适用法律下的相关权利，',
      p3: '请通过以下方式联系我们：',
      email: '联系邮箱：contact@oredact.com',
      p4: '我们将在收到请求后 30 日内 予以回复。',
    },
  },

  // Terms of Service Page
  termsOfService: {
    heroTitle: '用户服务协议',
    lastUpdated: '最后更新时间：2026 年 1 月 6 日',
    introduction: {
      title: '引言',
      p1: '欢迎使用 ORedact 隐私保护服务！',
      p2: '本用户服务协议（以下简称"本协议"）由您（个人或组织，以下简称"用户"）与',
      p3: '郑州欧睿达信息科技有限公司（以下简称"我们"、"公司"或"ORedact"）就您使用 ORedact 提供的隐私信息识别与脱敏技术服务所订立。',
      p4: '请您在使用服务前仔细阅读并充分理解本协议的全部条款。',
      p5: '一旦您开始使用我们的服务，即视为您已同意受本协议的约束。',
      p6: '如您不同意本协议的任何内容，请勿使用本服务。',
    },
    section1: {
      title: '1. 定义',
      service: {
        term: '"服务"',
        desc: '指 ORedact 提供的隐私信息识别与脱敏处理技术服务，包括图片、视频的隐私打码，经评估后提供的文字、文件脱敏，以及相关 API、平台与技术支持。',
      },
      user: {
        term: '"用户"',
        desc: '指注册、访问或使用本服务的个人、企业或其他组织。',
      },
      content: {
        term: '"内容"',
        desc: '指用户上传、提交、调用或通过本服务处理的任何数据、文件或信息。',
      },
      account: {
        term: '"账户"',
        desc: '指用户在 ORedact 平台上注册并用于访问服务的账户。',
      },
      ip: {
        term: '"知识产权"',
        desc: '指专利、商标、著作权、商业秘密及其他依法受保护的权利。',
      },
    },
    section2: {
      title: '2. 服务说明',
      subsection1: {
        title: '2.1 服务内容',
        p1: 'ORedact 提供基于人工智能与自动化技术的隐私保护服务，包括但不限于：',
        items: [
          '文本隐私信息识别与脱敏',
          '文档（如 PDF、Word 等）隐私信息检测与处理',
          '图片中隐私区域识别与遮挡',
          '视频中隐私内容的动态识别、跟踪与打码',
          '相关 API 接口、SDK 及技术支持服务',
        ],
        important: '重要说明：',
        importantNote: 'ORedact 提供的是技术处理工具与能力，不构成法律、合规或监管结论。',
      },
      subsection2: {
        title: '2.2 服务可用性',
        p1: '我们将合理努力保障服务的连续性与稳定性，但不保证服务不发生中断、延迟或错误。',
        p2: '服务可能因维护、升级、系统调整或不可抗力等原因暂时中断，我们将尽力提前通知。',
      },
    },
    section3: {
      title: '3. 用户账户',
      subsection1: {
        title: '3.1 账户注册',
        items: [
          '您应提供真实、准确、完整的注册信息',
          '您有责任保持账户信息的及时更新',
          '您应妥善保管账户凭据并对账户下的所有活动负责',
        ],
      },
      subsection2: {
        title: '3.2 账户使用',
        items: [
          '每个账户仅供一个用户或组织使用',
          '不得转让、出租或共享账户',
          '如发现账户被盗用或存在安全风险，应立即通知我们',
          '我们有权对违规账户采取限制、暂停或终止措施',
        ],
      },
    },
    section4: {
      title: '4. 使用规则与限制',
      subsection1: {
        title: '4.1 允许的使用',
        p1: '您仅可在以下范围内使用服务：',
        items: [
          '用于合法、正当的隐私保护或数据合规目的',
          '遵守适用的法律法规及本协议约定',
          '不侵犯任何第三方的合法权益',
        ],
      },
      subsection2: {
        title: '4.2 禁止的使用',
        p1: '您不得将服务用于以下情形，包括但不限于：',
        items: [
          '任何违法、欺诈、侵权或有害活动',
          '侵犯他人隐私权、知识产权或其他合法权益',
          '传播恶意代码、病毒或实施网络攻击',
          '规避、破坏或测试服务的安全机制',
          '对服务进行逆向工程、反编译或非法抓取',
          '超出合理使用范围的高频、大规模或异常请求',
        ],
      },
      subsection3: {
        title: '4.3 使用限制',
        p1: '服务可能受以下限制约束：',
        items: [
          'API 调用频率',
          '单文件大小与数量',
          '存储空间或任务并发数量',
        ],
        p2: '具体限制以平台页面或双方约定为准。',
      },
    },
    section5: {
      title: '5. 知识产权',
      subsection1: {
        title: '5.1 ORedact 的知识产权',
        p1: '服务本身及其相关软件、系统、算法、界面、商标等知识产权均归 ORedact 所有。',
        p2: '本协议不向用户转让任何知识产权，仅授予有限、非独占、不可转让的使用许可。',
      },
      subsection2: {
        title: '5.2 用户内容',
        items: [
          '用户保留其上传内容的所有权',
          '用户授予 ORedact 为提供服务所必需的技术处理许可',
          '用户确认其对上传内容拥有合法权利或授权',
        ],
        important: 'ORedact 不会将用户内容用于模型训练、数据分析、广告或任何与服务无关的目的。',
      },
      subsection3: {
        title: '5.3 侵权处理',
        p1: '如您认为服务内容侵犯了您的合法权益，请通过本协议列明的联系方式通知我们，我们将依法处理。',
      },
    },
    section6: {
      title: '6. 费用与支付',
      subsection1: {
        title: '6.1 服务费用',
        items: [
          '部分服务可能需付费使用',
          '具体价格以官网展示或双方约定为准',
          '我们有权依法调整价格，并提前通知',
        ],
      },
      subsection2: {
        title: '6.2 支付条款',
        items: [
          '用户应按约定方式与期限完成支付',
          '逾期付款可能导致服务暂停或终止',
          '退款政策以具体产品或合同约定为准',
        ],
      },
      subsection3: {
        title: '6.3 税费',
        p1: '除非另有说明，所有费用均不含适用税费，相关税费由用户自行承担。',
      },
    },
    section7: {
      title: '7. 免责声明',
      subsection1: {
        title: '7.1 服务免责',
        p1: '服务按"现状"提供，我们不对以下事项作出保证：',
        items: [
          '服务完全无误或不中断',
          '处理结果的绝对准确性或完整性',
          '服务适用于用户的特定业务或合规需求',
        ],
      },
      subsection2: {
        title: '7.2 内容免责',
        p1: '我们不对用户上传内容承担任何责任，包括但不限于：',
        items: [
          '内容的合法性、真实性或完整性',
          '内容涉及的第三方权利',
          '因内容产生的任何损失或后果',
        ],
      },
    },
    section8: {
      title: '8. 责任限制',
      p1: '在法律允许的最大范围内：',
      items: [
        '我们的累计责任不超过用户在过去 12 个月内向我们支付的服务费用',
        '不对间接、附带、特殊或后果性损失承担责任',
        '不对利润损失、数据丢失或业务中断承担责任',
      ],
      p2: '部分司法管辖区可能不允许上述限制，届时以适用法律为准。',
    },
    section9: {
      title: '9. 用户责任与赔偿',
      subsection1: {
        title: '9.1 用户责任',
        p1: '用户应：',
        items: [
          '确保上传内容合法且有权处理',
          '遵守法律法规与本协议',
          '保障账户与数据安全',
        ],
      },
      subsection2: {
        title: '9.2 安全义务',
        p1: '用户不得：',
        items: [
          '未经授权访问系统或数据',
          '干扰或破坏服务运行',
          '传播恶意程序或攻击系统',
        ],
      },
      subsection3: {
        title: '9.3 赔偿',
        p1: '因用户违反本协议或违法使用服务而导致的任何索赔、损失或费用，用户应对 ORedact 进行赔偿并免责。',
      },
    },
    section10: {
      title: '10. 协议终止',
      subsection1: {
        title: '10.1 终止情形',
        p1: '在以下情况下，我们有权暂停或终止服务：',
        items: [
          '用户违反本协议',
          '从事非法或高风险行为',
          '长期不使用账户',
          '未按约定支付费用',
        ],
      },
      subsection2: {
        title: '10.2 终止后果',
        items: [
          '用户将失去服务访问权',
          '我们可依法删除账户与相关数据',
          '已支付费用原则上不予退还',
        ],
      },
    },
    section11: {
      title: '11. 其他条款',
      subsection1: {
        title: '11.1 协议修改',
        p1: '我们可能不时更新本协议。重大变更将通过网站公告或邮件通知。',
        p2: '继续使用服务即视为接受修改后的协议。',
      },
      subsection2: {
        title: '11.2 适用法律与争议解决',
        p1: '本协议受中华人民共和国法律管辖。',
        p2: '因本协议产生的争议，提交北京仲裁委员会仲裁解决。',
      },
      subsection3: {
        title: '11.3 可分割性',
        p1: '如本协议部分条款无效，其余条款仍然有效。',
      },
      subsection4: {
        title: '11.4 完整协议',
        p1: '本协议构成双方就服务使用达成的完整协议。',
      },
    },
    section12: {
      title: '12. 联系我们',
      p1: '如您对本协议有任何疑问，请通过以下方式联系我们：',
      email: '联系邮箱：contact@oredact.com',
      p2: '感谢您选择 ORedact。',
      p3: '我们致力于为您提供安全、可靠、可审计的隐私保护技术服务。',
    },
  },
  damayaPage: {
    heroTitle: "打码鸭",
    heroSubtitle: "在线 AI 图片视频打码工具：上传后自动识别人脸、车牌和敏感文字，一键生成遮挡结果，手机和电脑浏览器直接用。",
    heroNote: "打码鸭官网 damaya.cn，由郑州欧睿达信息科技有限公司（ORedact）开发运营。",
    open: "打开打码鸭",
    help: "帮助中心",
    featuresTitle: "打码鸭能做什么",
    f1Title: "自动识别", f1Desc: "上传图片或视频后自动找出人脸、车牌和文字，不用手动框选。",
    f2Title: "视频持续遮挡", f2Desc: "同一个人或车牌连续出现时整理成轨迹，走动、转头、驶过都跟着遮。",
    f3Title: "按人物保留", f3Desc: "识别结果按人物区分，可以保留自己或已授权的人，其他人照常打码；漏掉的可以手动补。",
    f4Title: "五种样式", f4Desc: "马赛克、模糊、实色、遮眼条、贴纸，在浏览器里预览确认后再导出。",
    stylesTitle: "同一张图的四种效果",
    stylesDesc: "原图为 AI 生成，不涉及真实个人；四种效果都是打码鸭线上流程的真实输出，人脸和车牌一起处理。",
    styleBefore: "原图（AI 生成）", styleBlur: "模糊", styleMosaic: "马赛克", styleSolid: "实色遮挡", styleEyebar: "遮眼黑条",
    stepsTitle: "三步完成",
    s1Title: "上传", s1Desc: "支持 JPG、PNG、WebP、MP4、MOV，不用注册就能试。",
    s2Title: "确认", s2Desc: "系统自动识别后在编辑器里复核：保留谁、补哪里、用什么样式。",
    s3Title: "下载", s3Desc: "带水印版免费下载；无水印版按账户额度或套餐。处理记录 24 小时内可回来调整。",
    faqTitle: "常见问题",
    q1: "打码鸭需要下载软件吗？", q1A: "不需要。在浏览器里打开 damaya.cn 就能用，手机和电脑都可以。",
    q2: "打码鸭免费吗？", q2A: "识别和打码每天有免费额度，带打码鸭水印的结果免费下载；无水印版本按登录账户的次数或套餐计。具体规则以打码鸭站内说明为准。",
    q3: "上传的文件安全吗？", q3A: "原文件和结果在处理完成后 24 小时内自动删除，不用于模型训练；服务部署在境内。详见隐私政策。",
    q4: "打码鸭和 ORedact API 是什么关系？", q4A: "同一套识别与处理引擎。打码鸭面向自助用户，ORedact API 面向要把打码接进自己系统的团队。",
    companyTitle: "打码鸭由欧睿达开发运营",
    companyDesc: "郑州欧睿达信息科技有限公司只做图片与视频的隐私打码：自研处理流程和识别模型，线上产品打码鸭，企业接入用 ORedact API。",
    apiLink: "企业 API",
    aboutLink: "关于欧睿达",
  },
};
